import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const container = css`
  margin: 0 0 ${spacing.xxl}px;
`;

export const feefoWidgetContainer = css`
  max-width: ${pxToRem(700)};
  margin: ${spacing.xxl}px auto;
  text-align: center;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      min-height: ${pxToRem(1000)};
    `,
  )};
`;
